// @flow
import React, { Component } from 'react';
import BanneringBannerCards from 'containers/list/BanneringBannerCards';
import ScrollToTop from 'components/common/ScrollToTop';
import BanneringTemplate from 'components/bannering/BanneringTemplate/BanneringTemplate';
import { Helmet } from 'react-helmet';
import type { ContextRouter } from 'react-router-dom';
import queryString from 'query-string';

type Props = {} & ContextRouter;

class Bannering extends Component<Props> {
  render() {
    const { location, match, history } = this.props;
    const { sort } = queryString.parse(location.search);
    const { category } = match.params;
    return (
      <BanneringTemplate>
        <Helmet>
          <title>배너 | 캐시바이</title>
          <meta
            name="description"
            content="캐시바이에 방금 등록된 따끈따끈한 배너들을 살펴보세요."
          />
        </Helmet>
        <BanneringBannerCards category={category} sort={sort} />
      </BanneringTemplate>
    );
  }
}

export default Bannering;



// WEBPACK FOOTER //
// ./src/pages/Bannering.js